import type { TypeParcours } from '../types/database';

export const typesParcoursData: TypeParcours[] = [
  {
    id: 'troubles-visuels',
    nom: 'Troubles visuels',
    picto: 'Eye',
    classe: 'visuels'
  },
  {
    id: 'troubles-auditifs',
    nom: 'Troubles auditifs',
    picto: 'Ear',
    classe: 'auditifs'
  },
  {
    id: 'troubles-moteurs',
    nom: 'Troubles moteurs',
    picto: 'Hand',
    classe: 'moteurs'
  },
  {
    id: 'troubles-cognitifs',
    nom: 'Troubles cognitifs',
    picto: 'Brain',
    classe: 'cognitifs'
  },
  {
    id: 'troubles-intellectuels',
    nom: 'Troubles intellectuels',
    picto: 'Brain',
    classe: 'intellectuels'
  }
];